import DOMPurify from 'dompurify';

/**
* Converts markdown bold syntax (**text**) to HTML bold tags
* @param text - The text containing markdown bold syntax
* @returns HTML string with bold tags
*/
export const convertMarkdownBold = (text: string): string => {
 const converted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
 return (DOMPurify as unknown as { sanitize: (text: string) => string }).sanitize(
   converted
 );
};